if (!customElements.get('erp-upsell')) {
    class ErpUpsell extends ErpConnection {
  
      constructor() {
        super();

        this.messageQueue = new NotificationMessageQueue();
        this.configuration = this.querySelector('[data-configuration]');

        try {
            this.configuration = JSON.parse(this.configuration.innerText);
        } catch (err) {
            this.configuration = null;
        }
        
        if (this.configuration == null) return;

        this.section = this.querySelector('section');
        this.productList = this.querySelector('.product-list');
        this.recommendedProducts = [];
        this.upsellProductContainer = this.querySelector('[data-upsellProducts]');
 
        this.init();
      }
      
      init() {
        this.fetchProducts().then(() => {
          this.clearDuplicates();
          this.display();
        });
      }

      async fetchProducts() {
        var recommendedProducts = await this.fetchRecommendedProducts();
        var erpProducts = await this.fetchErpProducts();
        this.recommendedProducts = recommendedProducts.concat(erpProducts);
      }
      
      fetchRecommendedProducts() {
        return new Promise(resolve => {
          fetch("/recommendations/products.json?product_id=" + this.configuration.product_id)
            .then(response => response.json())
            .then(({ products }) => resolve(products));
        });
      }

      fetchErpProducts() {
        return new Promise(resolve => {
          let skus = this.configuration.pim_crossselling_skus.map(sku => `variants.sku:${sku}`);
          const url = new URL(`${window.location.origin}/search`);
          url.search = new URLSearchParams({ q: skus.join(' OR '), type: "product", view: `erp-upsell-sku-products` }).toString();
          fetch(url)
            .then(response => response.json())
            .then(json => resolve(json.results));
        });
      }
      
      display() {
        var self = this;

        if (this.recommendedProducts.length) {
          this.section.style.display = 'block';
        }
        
        var parser = new DOMParser();
        var products_per_row = (this.recommendedProducts.length > self.configuration.products_per_row) ? this.recommendedProducts.length : this.recommendedProducts.length;
        var grid_classes = [
          "1/4--lap",
          "1/" + (products_per_row - 1) + "--desk",
          "1/" + products_per_row + "--wide"
        ];

        this.recommendedProducts.forEach(function(product, index) {
          fetch("/products/" + product.handle + "?section_id=product-card").then(function(response) {
            return response.text().then(function(responseHTML) {
              var doc = parser.parseFromString(responseHTML, "text/html");
              grid_classes.forEach(className => doc.querySelector('.product-item').classList.add(className));
              self.upsellProductContainer.insertAdjacentHTML('afterbegin', doc.getElementById('shopify-section-product-card').innerHTML);
            });
          });
        });
      }
      
      clearDuplicates() {
        var uniqueRecommendedProducts = this.recommendedProducts.filter((arr, index, self) => index === self.findIndex((t) => (t.id === arr.id)))
        this.recommendedProducts = uniqueRecommendedProducts;
      }
    }
    
    customElements.define('erp-upsell', ErpUpsell);
}